export const getQueryKeysFactory = () => {
  //--------User----------->
  const userKeys = {
    membershipList: ['memberships'],
    me: ['me'],
  };

  //--------Organization----------->
  const organizationKeys = {
    integrationList: (organizationId: string) => [
      'organization',
      organizationId,
      'integrations',
    ],
    slackIntegrationUrl: (organizationId: string) => [
      'organization',
      organizationId,
      'slackIntegrationUrl',
    ],
    previewOrganization: (invitationCode?: string) => [
      'organization',
      'preview',
      invitationCode,
    ],
    organizationMemberList: (organizationId: string) => [
      'organization',
      organizationId,
      'members',
    ],
    organizationLimits: (organizationId: string) => [
      'organization',
      organizationId,
      'limits',
    ],
    scheduleList: (organizationId: string) => [
      'organization',
      organizationId,
      'schedules',
    ],
    scheduleById: (organizationId: string, scheduleId: string) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
    ],
    scheduleMemberList: (organizationId: string, scheduleId: string) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'members',
    ],
    scheduleRotations: (organizationId: string, scheduleId: string) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'rotations',
    ],
    scheduleRotationsDate: (
      organizationId: string,
      scheduleId: string,
      date: string
    ) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'rotations',
      date,
    ],
    scheduleRotationById: (
      organizationId: string,
      scheduleId: string,
      rotationId: string
    ) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'rotation',
      rotationId,
    ],
    userRotations: (organizationId: string, date: string) => [
      'organization',
      organizationId,
      'user',
      'rotations',
      date,
    ],
    userFeedbacks: (organizationId: string) => [
      'organization',
      organizationId,
      'user',
      'feedbacks',
    ],
    availableActions: (organizationId: string) => [
      'organization',
      organizationId,
      'actions',
    ],
    scheduleActions: (organizationId: string, scheduleId: string) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'actions',
    ],
    scheduleAnalyticsSummary: (
      organizationId: string,
      scheduleId: string,
      startDate: string,
      endDate: string
    ) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'analytics',
      'summary',
      startDate,
      endDate,
    ],
    scheduleAnalyticsTrend: (
      organizationId: string,
      scheduleId: string,
      type: string,
      granularity: string,
      startDate: string,
      endDate: string
    ) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'analytics',
      type,
      granularity,
      startDate,
      endDate,
    ],
    scheduleAnalyticsMemberPerformance: (
      organizationId: string,
      scheduleId: string,
      startDate: string,
      endDate: string
    ) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'analytics',
      'member-performance',
      startDate,
      endDate,
    ],
    scheduleFeedbacks: (
      organizationId: string,
      scheduleId: string,
      startDate: string,
      endDate: string
    ) => [
      'organization',
      organizationId,
      'schedule',
      scheduleId,
      'feedbacks',
      startDate,
      endDate,
    ],
  };

  const billingKeys = {
    createPortalSession: () => ['billing', 'portal-session', 'create'] as const,
  };

  return {
    userKeys,
    organizationKeys,
    billingKeys,
  };
};
